import { render } from "./ImgCropper.vue?vue&type=template&id=10038794&ts=true"
import script from "./ImgCropper.vue?vue&type=script&lang=ts"
export * from "./ImgCropper.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__